import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="location-selector"
export default class extends Controller {
  static targets = ["select", "form", "loadingIndicator"]
  static values = {
    autoSubmit: { type: Boolean, default: true }
  }

  connect() {
    this.submitInProgress = false
  }

  change(event) {
    if (this.autoSubmitValue && !this.submitInProgress) {
      this.submitForm()
    }
  }

  submitForm() {
    if (this.submitInProgress) return

    this.submitInProgress = true

    // Show loading state
    this.showLoading()

    setTimeout(() => {
      if (this.hasFormTarget) {
        this.formTarget.submit()
      }
    }, 150)
  }

  showLoading() {
    // Add visual loading state WITHOUT disabling (disabled fields are not submitted!)
    if (this.hasSelectTarget) {
      this.selectTarget.classList.add('opacity-50', 'cursor-wait', 'pointer-events-none')
    }

    // Show loading indicator if available
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.remove('hidden')
    }
  }

  hideLoading() {
    // Remove loading state
    if (this.hasSelectTarget) {
      this.selectTarget.classList.remove('opacity-50', 'cursor-wait', 'pointer-events-none')
    }

    // Hide loading indicator if available
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.add('hidden')
    }

    this.submitInProgress = false
  }

  // Public method to manually trigger a location change
  selectLocation(locationId) {
    if (this.hasSelectTarget) {
      this.selectTarget.value = locationId
      this.submitForm()
    }
  }
}
